import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client, throwFriendlyApiError } from '../common';
import type { AuthTokenResponse } from './use-create-customer';

type Variables = {
  email: string;
  password: string;
};

export const useLoginCustomer = createMutation<
  AuthTokenResponse,
  Variables,
  AxiosError
>({
  mutationFn: async ({ email, password }) =>
    client({
      url: 'v2/login',
      method: 'POST',
      data: { email, password },
    })
      .then((response) => response.data)
      .catch((err: any) => throwFriendlyApiError(err, 'log in')),
});
